<template>
  <Notifications
    position="bottom center"
    :duration="NOTIFICATION_DURATION_MS"
    style="bottom: 3.75rem"
    data-testid="app-notifications"
  >
    <template #body="props">
      <div class="relative mb-1 w-full min-w-0 max-w-md">
        <div
          class="absolute inset-0 rounded-[6px] bg-black-opaced backdrop-blur-2xl"
        />
        <div
          :data-variant="props.item.type"
          :class="
            isInfoNotification(props.item.type)
              ? 'border-blue-primary'
              : props.item.type == 'warn'
                ? 'border-yellow-primary'
                : 'border-red-primary'
          "
          class="relative z-10 flex min-h-11 items-start gap-2 rounded-[6px] border px-3 py-2.5 text-white-primary"
        >
          <InfoCircleIcon
            v-if="isInfoNotification(props.item.type)"
            class="mt-0.5 h-5 w-5 shrink-0 text-blue-primary"
          />
          <AlertIcon
            v-else
            :class="
              props.item.type == 'warn'
                ? 'text-yellow-primary'
                : 'text-red-primary'
            "
            class="mt-0.5 h-5 w-5 shrink-0"
          />
          <div class="min-h-0 min-w-0 flex-1">
            <p
              v-if="props.item.title"
              class="mb-1 text-sm font-medium leading-snug"
            >
              {{ props.item.title }}
            </p>
            <div
              class="max-h-[min(42vh,14rem)] overflow-y-auto overscroll-y-contain pr-0.5"
            >
              <p class="break-words text-xs leading-relaxed">
                {{
                  props.item.text && resolveApiNotifyText(props.item.text, t)
                }}
              </p>
            </div>
          </div>
          <button
            type="button"
            class="mt-0.5 shrink-0 rounded border border-gray-secondary p-1"
            @click="props.close"
          >
            <CrossIcon class="h-2 w-2 text-white-primary" />
          </button>
        </div>
      </div>
    </template>
  </Notifications>
</template>
<script setup lang="ts">
import { Notifications } from "@kyvg/vue3-notification";
import CrossIcon from "@/icons/cross.svg";
import InfoCircleIcon from "@/icons/info-circle.svg";
import AlertIcon from "@/icons/alert.svg";

import { useI18n } from "vue-i18n";
import { resolveApiNotifyText } from "@/utils/apiHttpError";

const { t } = useI18n();

const NOTIFICATION_DURATION_MS = 10_000;

function isInfoNotification(type: string | undefined) {
  return type === "success" || type === "info";
}
</script>
